export default "__VITE_ASSET__e4a90b0a__"